export const resolveLabel = (code, list) => {
  if (!code || !Array.isArray(list)) return 'N/A';
  return list.find((i) => i.code === code)?.label || code;
};
/* ================= ISSUER ================= */

export const ISSUER_CODES = [
  {
    tier: '156',
    class: '1561',
    code: '156101',
    category: 'Counterparty',
    subClass: 'Issuer',
    label: 'Issuer Name',
    inputType: 'multi-select text'
  },
  {
    tier: '156',
    class: '1561',
    code: '156102',
    category: 'Counterparty',
    subClass: 'Liquidity Provider',
    label: 'Liquidity Provider Name',
    inputType: 'multi-select text'
  }
];

/* ================= TRADING_TYPE ================= */

/* ================= COMPOSITION ================= */

export const COMPOSITION_TYPE_CODES = [
  {
    tier: '151',
    class: '1511',
    code: '151101',
    category: 'Single-Asset',
    subClass: 'Equity',
    label: 'Equity-Only DBT'
  },
  {
    tier: '151',
    class: '1511',
    code: '151102',
    category: 'Single-Asset',
    subClass: 'Fixed Income',
    label: 'Fixed-Income-Only DBT'
  },
  {
    tier: '151',
    class: '1511',
    code: '151103',
    category: 'Single-Asset',
    subClass: 'Commodity',
    label: 'Commodity-Only DBT'
  },
  {
    tier: '151',
    class: '1511',
    code: '151104',
    category: 'Single-Asset',
    subClass: 'Digital Assets',
    label: 'Digital-Asset-Only DBT'
  },
  {
    tier: '151',
    class: '1511',
    code: '151105',
    category: 'Single-Asset',
    subClass: 'Real Estate',
    label: 'Real-Estate-Only DBT'
  },

  {
    tier: '151',
    class: '1512',
    code: '151201',
    category: 'Multi-Asset',
    subClass: 'Equity+Digital',
    label: 'Equity + Digital Assets DBT'
  },
  {
    tier: '151',
    class: '1512',
    code: '151202',
    category: 'Multi-Asset',
    subClass: 'Fixed+Digital',
    label: 'Fixed Income + Digital Assets DBT'
  },
  {
    tier: '151',
    class: '1512',
    code: '151203',
    category: 'Multi-Asset',
    subClass: 'Commodity+Digital',
    label: 'Commodity + Digital Assets DBT'
  },
  {
    tier: '151',
    class: '1512',
    code: '151204',
    category: 'Multi-Asset',
    subClass: 'RWA+Digital',
    label: 'Real-World Assets + Digital Assets DBT'
  },
  {
    tier: '151',
    class: '1512',
    code: '151205',
    category: 'Multi-Asset',
    subClass: 'Full Multi-Asset',
    label: 'Full Multi-Asset DBT'
  }
];

/* ================= LIQUIDITY ================= */

export const LIQUIDITY_TYPE_CODES = [
  {
    tier: '161',
    class: '1611',
    code: '161101',
    category: 'Liquidity',
    subClass: 'Exchange',
    label: 'Exchange-Listed DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161102',
    category: 'Liquidity',
    subClass: 'OTC',
    label: 'OTC-Traded DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161103',
    category: 'Liquidity',
    subClass: 'AMM',
    label: 'Smart-Contract AMM-Traded DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161104',
    category: 'Liquidity',
    subClass: 'Liquidity-Pool',
    label: 'Liquidity-Pool Backed DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161105',
    category: 'Liquidity',
    subClass: 'Market-Maker',
    label: 'Market-Maker Supported DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161106',
    category: 'Liquidity',
    subClass: 'Low-Liquidity',
    label: 'Low-Liquidity DBT'
  },
  {
    tier: '161',
    class: '1611',
    code: '161107',
    category: 'Liquidity',
    subClass: 'High-Liquidity',
    label: 'High-Liquidity DBT'
  }
];

/* ================= ASSET ================= */

export const ASSET_TYPE_CODES = [
  {
    tier: '154',
    class: '1541',
    code: '154101',
    category: 'Underlying',
    subClass: 'Digital Assets',
    label: 'Digital Assets (Layer-1/Layer-2/Utility)',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154102',
    category: 'Underlying',
    subClass: 'Stablecoins',
    label: 'Stablecoins',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154103',
    category: 'Underlying',
    subClass: 'Tokenized Equities',
    label: 'Tokenized Equities',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154104',
    category: 'Underlying',
    subClass: 'Tokenized Bonds',
    label: 'Tokenized Bonds / DCNs',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154105',
    category: 'Underlying',
    subClass: 'Tokenized Commodities',
    label: 'Tokenized Commodities',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154106',
    category: 'Underlying',
    subClass: 'Tokenized Real Estate',
    label: 'Tokenized Real Estate',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154107',
    category: 'Underlying',
    subClass: 'Tokenized Funds',
    label: 'Tokenized Funds / Other DBTs',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154108',
    category: 'Underlying',
    subClass: 'Revenue Tokens',
    label: 'Revenue-Backed Tokens',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154109',
    category: 'Underlying',
    subClass: 'Operational Tokens',
    label: 'Operational Tokens',
    inputType: 'multi-select'
  },
  {
    tier: '154',
    class: '1541',
    code: '154110',
    category: 'Underlying',
    subClass: 'Wrapped Assets',
    label: 'Wrapped Assets (BTC/ETH/SOL/etc.)',
    inputType: 'multi-select'
  }
];

/* ================= COLLATERALIZATION_LEVEL ================= */

export const COLLATERALIZATION_LEVEL_TYPE_CODES = [
  {
    tier: '155',
    class: '1551',
    code: '155101',
    category: 'Collateralization',
    subClass: 'Fully',
    label: '100% Fully Collateralized DAT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155102',
    category: 'Collateralization',
    subClass: 'Over',
    label: 'Over-Collateralized DAT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155103',
    category: 'Collateralization',
    subClass: 'Partial',
    label: 'Partially Collateralized DAT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155104',
    category: 'Collateralization',
    subClass: 'Dynamic',
    label: 'Dynamic Collateralization DAT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155105',
    category: 'Collateralization',
    subClass: 'Volatility-Responsive',
    label: 'Volatility-Responsive Collateralization DAT'
  }
];

/* ================= REBALANCING ================= */

export const REBALANCING_TYPE_CODES = [
  {
    tier: '153',
    class: '1531',
    code: '153101',
    category: 'Rebalance',
    subClass: 'Monthly',
    label: 'Monthly Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153102',
    category: 'Rebalance',
    subClass: 'Quarterly',
    label: 'Quarterly Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153103',
    category: 'Rebalance',
    subClass: 'Semiannual',
    label: 'Semiannual Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153104',
    category: 'Rebalance',
    subClass: 'Annual',
    label: 'Annual Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153105',
    category: 'Rebalance',
    subClass: 'Threshold',
    label: 'Threshold-Triggered Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153106',
    category: 'Rebalance',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Auto-Rebalance DBT'
  },
  {
    tier: '153',
    class: '1531',
    code: '153107',
    category: 'Rebalance',
    subClass: 'Static',
    label: 'No-Rebalance (Static Basket) DBT'
  }
];

/* ================= COMPLIANCE ================= */

export const COMPLIANCE_TYPE_CODES = [
  {
    tier: '160',
    class: '1601',
    code: '160101',
    category: 'Compliance',
    subClass: 'Reg D',
    label: 'Reg D DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160102',
    category: 'Compliance',
    subClass: 'Reg S',
    label: 'Reg S DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160103',
    category: 'Compliance',
    subClass: '144A',
    label: '144A DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160104',
    category: 'Compliance',
    subClass: 'Retail',
    label: 'Retail-Eligible DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160105',
    category: 'Compliance',
    subClass: 'Institutional',
    label: 'Institutional-Only DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160106',
    category: 'Compliance',
    subClass: 'QP',
    label: 'Qualified Purchaser DBT'
  },
  {
    tier: '160',
    class: '1601',
    code: '160107',
    category: 'Compliance',
    subClass: 'Restricted',
    label: 'Restricted DBT'
  }
];

/* ================= STRUCTURE ================= */

export const STRUCTURE_TYPE_CODES = [
  {
    tier: '150',
    class: '1501',
    code: '150101',
    category: 'DBT Structure',
    subClass: 'Treasury-Backed',
    label: 'Digital Asset Treasury-Backed DBT (On-Chain Collateral)'
  },
  {
    tier: '150',
    class: '1501',
    code: '150102',
    category: 'DBT Structure',
    subClass: 'Synthetic',
    label: 'Synthetic DBT (Smart-Contract Exposure)'
  },
  {
    tier: '150',
    class: '1501',
    code: '150103',
    category: 'DBT Structure',
    subClass: 'Hybrid',
    label: 'Optimized DBT (Hybrid Physical + Synthetic)'
  },
  {
    tier: '150',
    class: '1501',
    code: '150104',
    category: 'DBT Structure',
    subClass: 'Rules-Based',
    label: 'Rules-Based DBT'
  },
  {
    tier: '150',
    class: '1501',
    code: '150105',
    category: 'DBT Structure',
    subClass: 'Active',
    label: 'Actively Managed DBT'
  },
  {
    tier: '150',
    class: '1501',
    code: '150106',
    category: 'DBT Structure',
    subClass: 'Factor',
    label: 'Factor-Driven DBT'
  },
  {
    tier: '150',
    class: '1501',
    code: '150107',
    category: 'DBT Structure',
    subClass: 'Thematic',
    label: 'Thematic DBT'
  }
];

/* ================= INVESTMENT-GRADE ================= */

export const INVESTMENT_GRADE_CODES = [
  {
    tier: 150,
    class: 1502,
    code: 150201,
    category: 'DBT Investment Grade',
    subClass: 'Prime',
    label: 'Prime Grade DBT (High Quality / High Transparency)'
  },
  {
    tier: 150,
    class: 1502,
    code: 150202,
    category: 'DBT Investment Grade',
    subClass: 'Standard',
    label: 'Standard Grade DBT (Typical Market Quality)'
  },
  {
    tier: 150,
    class: 1502,
    code: 150203,
    category: 'DBT Investment Grade',
    subClass: 'Speculative',
    label: 'Speculative Grade DBT (High Risk / High Variance)'
  },
  {
    tier: 150,
    class: 1503,
    code: 150301,
    category: 'DBT Exemption Reference',
    subClass: 'RegD',
    label: 'Reg D Exempt DBT (Accredited Investors)'
  },
  {
    tier: 150,
    class: 1503,
    code: 150302,
    category: 'DBT Exemption Reference',
    subClass: 'RegS',
    label: 'Reg S Exempt DBT (Non‑US Investors)'
  },
  {
    tier: 150,
    class: 1503,
    code: 150303,
    category: 'DBT Exemption Reference',
    subClass: 'RegAPlus',
    label: 'Reg A+ Qualified DBT'
  },
  {
    tier: 150,
    class: 1503,
    code: 150304,
    category: 'DBT Exemption Reference',
    subClass: 'RegCF',
    label: 'Reg CF Crowdfunding DBT'
  },
  {
    tier: 150,
    class: 1504,
    code: 150401,
    category: 'DBT Geographic Region',
    subClass: 'NorthAmerica',
    label: 'North America DBT'
  },
  {
    tier: 150,
    class: 1504,
    code: 150402,
    category: 'DBT Geographic Region',
    subClass: 'Europe',
    label: 'Europe DBT'
  },
  {
    tier: 150,
    class: 1504,
    code: 150403,
    category: 'DBT Geographic Region',
    subClass: 'AsiaPacific',
    label: 'Asia‑Pacific DBT'
  },
  {
    tier: 150,
    class: 1504,
    code: 150404,
    category: 'DBT Geographic Region',
    subClass: 'LATAM',
    label: 'Latin America DBT'
  },
  {
    tier: 150,
    class: 1504,
    code: 150405,
    category: 'DBT Geographic Region',
    subClass: 'Global',
    label: 'Global Multi‑Region DBT'
  },
  {
    tier: 150,
    class: 1505,
    code: 150501,
    category: 'DBT Strategy Focus',
    subClass: 'Growth',
    label: 'Growth‑Focused DBT'
  },
  {
    tier: 150,
    class: 1505,
    code: 150502,
    category: 'DBT Strategy Focus',
    subClass: 'Value',
    label: 'Value‑Focused DBT'
  },
  {
    tier: 150,
    class: 1505,
    code: 150503,
    category: 'DBT Strategy Focus',
    subClass: 'Income',
    label: 'Income‑Focused DBT'
  },
  {
    tier: 150,
    class: 1505,
    code: 150504,
    category: 'DBT Strategy Focus',
    subClass: 'Thematic',
    label: 'Thematic DBT (Sector / Narrative Driven)'
  },
  {
    tier: 150,
    class: 1505,
    code: 150505,
    category: 'DBT Strategy Focus',
    subClass: 'RiskParity',
    label: 'Risk‑Parity DBT'
  }
];

/* ================= REGION ================= */

export const GEOGRAPHIC_REGION_CODES = [
  {
    tier: 151,
    class: 1510,
    code: 151010,
    category: 'DBT Region - Americas',
    subClass: 'North America',
    label: 'United States & Canada'
  },
  {
    tier: 151,
    class: 1510,
    code: 151020,
    category: 'DBT Region - Americas',
    subClass: 'North America',
    label: 'Mexico & Central North America'
  },
  {
    tier: 151,
    class: 1511,
    code: 151110,
    category: 'DBT Region - Americas',
    subClass: 'Latin America',
    label: 'South America'
  },
  {
    tier: 151,
    class: 1511,
    code: 151120,
    category: 'DBT Region - Americas',
    subClass: 'Latin America',
    label: 'Central America & Caribbean'
  },

  {
    tier: 151,
    class: 1512,
    code: 151210,
    category: 'DBT Region - Europe',
    subClass: 'Western Europe',
    label: 'Eurozone'
  },
  {
    tier: 151,
    class: 1512,
    code: 151220,
    category: 'DBT Region - Europe',
    subClass: 'Western Europe',
    label: 'Non-Eurozone West'
  },
  {
    tier: 151,
    class: 1513,
    code: 151310,
    category: 'DBT Region - Europe',
    subClass: 'Eastern Europe',
    label: 'EU East'
  },
  {
    tier: 151,
    class: 1513,
    code: 151320,
    category: 'DBT Region - Europe',
    subClass: 'Eastern Europe',
    label: 'Non-EU East'
  },

  {
    tier: 151,
    class: 1514,
    code: 151410,
    category: 'DBT Region - Middle East & Africa',
    subClass: 'Middle East',
    label: 'Gulf States'
  },
  {
    tier: 151,
    class: 1514,
    code: 151420,
    category: 'DBT Region - Middle East & Africa',
    subClass: 'Middle East',
    label: 'Levant'
  },
  {
    tier: 151,
    class: 1515,
    code: 151510,
    category: 'DBT Region - Middle East & Africa',
    subClass: 'Africa',
    label: 'North Africa'
  },
  {
    tier: 151,
    class: 1515,
    code: 151520,
    category: 'DBT Region - Middle East & Africa',
    subClass: 'Africa',
    label: 'Sub-Saharan Africa'
  },

  {
    tier: 151,
    class: 1516,
    code: 151610,
    category: 'DBT Region - Asia',
    subClass: 'East Asia',
    label: 'China Mainland'
  },
  {
    tier: 151,
    class: 1516,
    code: 151620,
    category: 'DBT Region - Asia',
    subClass: 'East Asia',
    label: 'Japan'
  },
  {
    tier: 151,
    class: 1516,
    code: 151630,
    category: 'DBT Region - Asia',
    subClass: 'East Asia',
    label: 'Korea & Taiwan'
  },
  {
    tier: 151,
    class: 1517,
    code: 151710,
    category: 'DBT Region - Asia',
    subClass: 'South Asia',
    label: 'India'
  },
  {
    tier: 151,
    class: 1517,
    code: 151720,
    category: 'DBT Region - Asia',
    subClass: 'South Asia',
    label: 'Pakistan Bangladesh Sri Lanka'
  },

  {
    tier: 151,
    class: 1518,
    code: 151810,
    category: 'DBT Region - Southeast Asia',
    subClass: 'ASEAN Core',
    label: 'Singapore Malaysia Thailand'
  },
  {
    tier: 151,
    class: 1518,
    code: 151820,
    category: 'DBT Region - Southeast Asia',
    subClass: 'ASEAN Core',
    label: 'Indonesia Philippines Vietnam'
  },
  {
    tier: 151,
    class: 1519,
    code: 151910,
    category: 'DBT Region - Southeast Asia',
    subClass: 'Frontier Southeast Asia',
    label: 'Cambodia Laos Myanmar'
  },

  {
    tier: 151,
    class: 1520,
    code: 152010,
    category: 'DBT Region - Oceania',
    subClass: 'Pacific Developed',
    label: 'Australia'
  },
  {
    tier: 151,
    class: 1520,
    code: 152020,
    category: 'DBT Region - Oceania',
    subClass: 'Pacific Developed',
    label: 'New Zealand'
  },
  {
    tier: 151,
    class: 1521,
    code: 152110,
    category: 'DBT Region - Oceania',
    subClass: 'Pacific Islands',
    label: 'Fiji Samoa Papua New Guinea'
  }
];

/* ================= RISK ================= */

export const RISK_PROFILE_CODES = [
  {
    tier: '155',
    class: '1551',
    code: '155101',
    category: 'Risk',
    subClass: 'Low Volatility',
    label: 'Low-Volatility DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155102',
    category: 'Risk',
    subClass: 'Moderate Risk',
    label: 'Moderate-Risk DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155103',
    category: 'Risk',
    subClass: 'High Volatility',
    label: 'High-Volatility DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155104',
    category: 'Risk',
    subClass: 'Income',
    label: 'Income-Focused DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155105',
    category: 'Risk',
    subClass: 'Growth',
    label: 'Growth-Focused DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155106',
    category: 'Risk',
    subClass: 'Balanced',
    label: 'Balanced-Risk DBT'
  },
  {
    tier: '155',
    class: '1551',
    code: '155107',
    category: 'Risk',
    subClass: 'Hedge',
    label: 'Hedge-Oriented DBT'
  }
];

/* ================= FEE ================= */
export const FEE_TYPE_CODES = [
  {
    tier: '159',
    class: '1591',
    code: '159101',
    category: 'Fees',
    subClass: 'Fixed',
    label: 'Fixed Fee DBT'
  },
  {
    tier: '159',
    class: '1591',
    code: '159102',
    category: 'Fees',
    subClass: 'Performance',
    label: 'Performance Fee DBT'
  },
  {
    tier: '159',
    class: '1591',
    code: '159103',
    category: 'Fees',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Fee DBT'
  },
  {
    tier: '159',
    class: '1591',
    code: '159104',
    category: 'Fees',
    subClass: 'Dynamic',
    label: 'Dynamic Fee DBT'
  },
  {
    tier: '159',
    class: '1591',
    code: '159105',
    category: 'Fees',
    subClass: 'Zero-Fee',
    label: 'Zero-Fee DBT'
  }
];

/* ================= MECHANISM ================= */

export const MECHANISM_TYPE_CODES = [
  {
    tier: '158',
    class: '1581',
    code: '158101',
    category: 'Creation',
    subClass: 'On-Chain',
    label: 'On-Chain Creation/Redemption DBT'
  },
  {
    tier: '158',
    class: '1581',
    code: '158102',
    category: 'Creation',
    subClass: 'AP Model',
    label: 'Authorized Participant (AP) Model DBT'
  },
  {
    tier: '158',
    class: '1581',
    code: '158103',
    category: 'Creation',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Automated Creation DBT'
  },
  {
    tier: '158',
    class: '1581',
    code: '158104',
    category: 'Creation',
    subClass: 'Collateral-Swap',
    label: 'Collateral-Swap Redemption DBT'
  },
  {
    tier: '158',
    class: '1581',
    code: '158105',
    category: 'Creation',
    subClass: 'Cash-Only',
    label: 'Cash-Only Redemption DBT'
  },
  {
    tier: '158',
    class: '1581',
    code: '158106',
    category: 'Creation',
    subClass: 'In-Kind',
    label: 'In-Kind Redemption DBT'
  }
];

/* ================= TRANSPARENCY ================= */

export const TRANSPARENCY_TYPE_CODES = [
  {
    tier: '157',
    class: '1571',
    code: '157101',
    category: 'Transparency',
    subClass: 'On-Chain',
    label: 'Full On-Chain Transparency DBT'
  },
  {
    tier: '157',
    class: '1571',
    code: '157102',
    category: 'Transparency',
    subClass: 'Daily',
    label: 'Daily Holdings Disclosure DBT'
  },
  {
    tier: '157',
    class: '1571',
    code: '157103',
    category: 'Transparency',
    subClass: 'Monthly',
    label: 'Monthly Holdings Disclosure DBT'
  },
  {
    tier: '157',
    class: '1571',
    code: '157104',
    category: 'Transparency',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Verified Holdings DBT'
  },
  {
    tier: '157',
    class: '1571',
    code: '157105',
    category: 'Transparency',
    subClass: 'Audited',
    label: 'Audited Collateral DBT'
  },
  {
    tier: '157',
    class: '1571',
    code: '157106',
    category: 'Transparency',
    subClass: 'ZKP',
    label: 'Zero-Knowledge Proof Verified DBT'
  }
];

/* ================= WEIGHT ================= */

export const WEIGHT_TYPE_CODES = [
  {
    tier: '152',
    class: '1521',
    code: '152101',
    category: 'Weighting',
    subClass: 'Market-Cap',
    label: 'Market-Cap Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152102',
    category: 'Weighting',
    subClass: 'Equal',
    label: 'Equal-Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152103',
    category: 'Weighting',
    subClass: 'Factor',
    label: 'Factor-Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152104',
    category: 'Weighting',
    subClass: 'Risk-Parity',
    label: 'Risk-Parity Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152105',
    category: 'Weighting',
    subClass: 'Volatility',
    label: 'Volatility-Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152106',
    category: 'Weighting',
    subClass: 'Fundamental',
    label: 'Fundamental-Weighted DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152107',
    category: 'Weighting',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Dynamic Weighting DBT'
  },
  {
    tier: '152',
    class: '1521',
    code: '152108',
    category: 'Weighting',
    subClass: 'Custom',
    label: 'Custom Rules-Based Weighting DBT'
  }
];

/* ================= STRATEGY ================= */

export const STRATEGY_TYPE_CODES = [
  {
    tier: '156',
    class: '1561',
    code: '156101',
    category: 'Strategy',
    subClass: 'Index',
    label: 'Index-Tracking DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156102',
    category: 'Strategy',
    subClass: 'Smart-Beta',
    label: 'Smart-Beta DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156103',
    category: 'Strategy',
    subClass: 'Active',
    label: 'Active Strategy DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156104',
    category: 'Strategy',
    subClass: 'Sector',
    label: 'Sector-Focused DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156105',
    category: 'Strategy',
    subClass: 'Thematic',
    label: 'Thematic Strategy DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156106',
    category: 'Strategy',
    subClass: 'Yield',
    label: 'Yield-Focused DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156107',
    category: 'Strategy',
    subClass: 'Inflation-Hedge',
    label: 'Inflation-Hedge DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156108',
    category: 'Strategy',
    subClass: 'Liquidity-Pool',
    label: 'Liquidity-Pool DBT'
  },
  {
    tier: '156',
    class: '1561',
    code: '156109',
    category: 'Strategy',
    subClass: 'Collateral-Optimization',
    label: 'Collateral-Optimization DBT'
  }
];

/* ================= TREASURY ================= */

export const TREASURY_MGMT_CODES = [
  {
    tier: '177',
    class: '1771',
    code: '177101',
    category: 'Treasury',
    subClass: 'Issuer-Managed',
    label: 'Issuer-Managed Treasury'
  },
  {
    tier: '177',
    class: '1771',
    code: '177102',
    category: 'Treasury',
    subClass: 'DAT-Managed',
    label: 'DAT-Managed Treasury'
  },
  {
    tier: '177',
    class: '1771',
    code: '177103',
    category: 'Treasury',
    subClass: 'Smart-Contract',
    label: 'Smart-Contract Autonomous Treasury'
  },
  {
    tier: '177',
    class: '1771',
    code: '177104',
    category: 'Treasury',
    subClass: 'Hybrid',
    label: 'Hybrid Human + Smart-Contract Treasury'
  },
  {
    tier: '177',
    class: '1771',
    code: '177105',
    category: 'Treasury',
    subClass: 'Third-Party',
    label: 'Third-Party Custodied Treasury'
  }
];

/* ================= TREASURY_KEY ================= */

export const TREASURY_KEY_CODES = [
  {
    tier: 150,
    class: 1506,
    code: 150601,
    category: 'Digital Asset Treasury',
    subClass: 'DATKey',
    label: 'Digital Asset Treasury Key',
    inputType: 'text'
  }
];
